import { Container } from '@components/layout/grid'
import PhoneVerification from '@components/playbook/phone-verification'
import { GoogleAdsConversionEvent } from '@lib/analytics/googleAds/conversions'
import googleAdsService from '@lib/analytics/googleAds/GoogleAdsService'
import type { PageWithContext } from '@lib/utils/context'
import { getPlaybookLayout } from '@page-templates/playbook-page'
import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'

const PHONE_VERIFICATION_CONVERSION_KEY =
    'step_conversion_phone_verification_fired'

export const PhoneVerificationPage: PageWithContext = observer(() => {
    // Track phone verification page view as a conversion event (once per session)
    useEffect(() => {
        if (sessionStorage.getItem(PHONE_VERIFICATION_CONVERSION_KEY)) return

        googleAdsService.trackConversion(
            GoogleAdsConversionEvent.LENDING_PHONE_VERIFICATION,
        )
        sessionStorage.setItem(PHONE_VERIFICATION_CONVERSION_KEY, 'true')
    }, [])

    return (
        <Container>
            <PhoneVerification />
        </Container>
    )
})

PhoneVerificationPage.getLayout = getPlaybookLayout()

export default PhoneVerificationPage
